import { useSearchParams } from 'react-router-dom';
import EnhancedCreatePetition from '../../components/petitions/CreatePetition/EnhancedCreatePetition';
import './EnhancedCreatePetitionPage.scss';

const EnhancedCreatePetitionPage = () => {
  const [searchParams] = useSearchParams();
  const useVoice = searchParams.get('voice') === 'true';

  return (
    <div className="enhanced-create-petition-page">
      <div className="container">
        <EnhancedCreatePetition 
          autoStartVoice={useVoice}
          showVoiceIntro={useVoice}
        />
      </div>
    </div>
  );
};

export default EnhancedCreatePetitionPage;